import * as types from "../action/ActionType";
import type { AppAction } from "../action/ActionType";

export default function DashboardReducer(state: boolean = false, action: AppAction): boolean {
  switch (action.type) {
    case types.ISUPDATED:
      return action.payload;
    default:
      return state;
  }
}
